angular.module('app').directive('chart', function() {
    return {
        'scope': {
            'chart': '=',
        },
        'link': function($scope, $elem) {

            $scope.ctx = $elem;

            if(!$scope.chart) {
                $scope.chart = {};
            }

            $scope.initChart = function() {
                $scope.chartObj = new Chart($scope.ctx, $scope.chart);
            };

            $scope.$watch('chart', function(oldVal, newVal) {
                if(!$scope.chart.type) {
                    return;
                }

                if($scope.chartObj) {
                    $scope.chartObj.destroy();
                } 
                $scope.initChart();
            });
        }
    };
});
